import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  inject,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { debounceTime, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { filterArrayByField } from '../utils/utils.functions';

@Component({
  selector: 'app-custom-drop-down',
  templateUrl: './custom-drop-down.component.html',
  styleUrl: './custom-drop-down.component.scss',
})
export class CustomDropDownComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() options: Array<any> = [];
  @Input() optionsDisplay: Array<any> = [];
  @Input() inputAutoCompletetWithTag: boolean = false;
  @Input() withSearch: boolean = true;
  @Input() parentForm: FormGroup;
  @Input() controlName: string = '';
  @Input() simpleDropDown: boolean = true;
  @Input() color: string = 'primary';
  @Input() errorMessage: string = 'requis';
  @Input() helper: string = '';
  @Input() parentGroupName: string;
  @Input() required: boolean = false;
  @Input() loading: boolean = false;
  @Input() multiple: boolean = false;
  @Input() apiFilter: boolean = false;
  @Input() positionIcon = 'left';
  @Input() sideIcon: string = '';
  @Input() class: string = '';
  @Input() innerClass: string = '';
  @Input() simpleDropDownClass: string = '';
  @Input() keyFilter: string = 'label';
  @Input() showFilter = true;
  @Output() keywordEmitter = new EventEmitter();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  inputControl = new FormControl('');
  filteredList: Observable<any[]>;
  tagValue: string[] = [''];
  @Input() inputPlaceHolder: string;
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  announcer = inject(LiveAnnouncer);
  keyword: FormControl = new FormControl('');
  constructor() {
    if (this.inputAutoCompletetWithTag) {
      this.simpleDropDown = false;
    }
    this.filteredList = this.inputControl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) =>
        fruit ? this._filter(fruit) : this.options.slice()
      )
    );
    // this.errorMessage =
    //   Object.keys(this.parentForm?.controls[this.controlName].errors || {})[0]
    //   || Object.keys(this.parentForm?.get(this.parentGroupName)?.get(this.controlName)?.errors || {})[0]
  }

  ngOnInit() {
    this.optionsDisplay = this.options;
    this.keyword.valueChanges
      .pipe(debounceTime(150))
      .subscribe((value: string) => {
        if (this.apiFilter) {
          this.keywordEmitter.emit(value);
        } else {
          this.optionsDisplay = this._filter(value);
        }
      });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']?.currentValue?.length) {
      this.optionsDisplay = changes['options']?.currentValue;
    }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) {
      this.options.push({ value: value, label: value });
      this.optionsDisplay = this.options;
    }

    // Clear the input value
    event.chipInput!.clear();

    this.inputControl.setValue(null);
  }

  remove(fruit: any): void {
    const index = this.options.indexOf(fruit);

    if (index >= 0) {
      this.options.splice(index, 1);
      this.optionsDisplay = this.options;
      this.announcer.announce(`Removed ${fruit}`);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.options.push({
      label: event.option.viewValue,
      value: event.option.viewValue,
    });
    this.optionsDisplay = this.options;
    this.fruitInput.nativeElement.value = '';
    this.inputControl.setValue(null);
  }

  /** Lowercase + strip accents + treat '-' as space, so "reanimation" matches "Anesthésie-réanimation". */
  private normalize(value: any): string {
    const lowered = (value ?? '').toString().toLowerCase().normalize('NFD');
    let out = '';
    for (const ch of lowered) {
      const code = ch.codePointAt(0) as number;
      if (code >= 0x300 && code <= 0x36f) continue; // skip combining accent marks
      out += ch === '-' ? ' ' : ch;
    }
    return out.trim();
  }

  private _filter(value: string): any[] {
    const filterValue = this.normalize(value);
    return this.options.filter((op) => {
      const filterField = op[this.keyFilter] ?? op['name'] ?? op['label'];
      return this.normalize(filterField).includes(filterValue);
    });
  }
  protected readonly filterArrayByField = filterArrayByField;
}
